const locale = "de-DE";
const translations = {
	timeFormat: "HH:mm",
	dateFormat: "DD.MM.YYYY",
	dateTimeFormat: "DD.MM.YYYY HH:mm",
	"serviceReports.headline": "Serviceberichte",
	"serviceReports.sublineMachine": "Sehen Sie sich die Serviceberichte zu Ihrer Maschine an und laden Sie sie herunter.",
	"serviceReports.technicianName": "Techniker-Name",
	"serviceReports.machineNameAndNumber": "Maschine & Maschinen Nr.",
	"serviceReports.startDate": "Von",
	"serviceReports.endDate": "Bis",
	"serviceReports.creationDate": "Erstellungsdatum",
	"serviceReports.openReport": "Servicebericht öffnen (PDF)",
	"serviceReports.filter": "Filter",
	"serviceReports.missionNumber": "Einsatznummer",
	"serviceReports.assignmentType": "Serviceberichtstyp",
	"serviceReports.reportTypes.IA": "Abbau- / Umstellungsbericht",
	"serviceReports.reportTypes.AC": "Applikationsberatungsbericht",
	"serviceReports.reportTypes.IV": "Installationsvorbereitungsbericht",
	"serviceReports.reportTypes.BA": "Bestandsaufnahmebericht",
	"serviceReports.reportTypes.UV": "Sicherheitsüberprüfungsbericht",
	"serviceReports.reportTypes.IG": "Aufbaubericht Gebrauchtmaschine",
	"serviceReports.reportTypes.UB": "Qualitätsmaßnahmebericht",
	"serviceReports.reportTypes.PN": "Produktionsbegleitungsbericht",
	"serviceReports.reportTypes.NR": "Funktionserweiterungsbericht",
	"serviceReports.reportTypes.IB": "Installation / Start-up report",
	"serviceReports.reportTypes.II": "Installationsintegrationsbericht",
	"serviceReports.reportTypes.IC": "Interne Reparatur Bericht",
	"serviceReports.reportTypes.MB": "Messebetreuungsbericht",
	"serviceReports.reportTypes.HW": "Ressourcenbericht",
	"serviceReports.reportTypes.TT": "Technikerschulungsbericht",
	"serviceReports.reportTypes.SK": "Kundeschulungsbericht",
	"serviceReports.reportTypes.RP": "Reparaturbericht",
	"serviceReports.reportTypes.RW": "Reparatur- und Wartungsbericht",
	"serviceReports.reportTypes.WA": "Wartungsbericht",
	"serviceReports.reportTypesPlural.IA": "Abbau- / Umstellungsberichte",
	"serviceReports.reportTypesPlural.AC": "Applikationsberatungsberichte",
	"serviceReports.reportTypesPlural.IV": "Installationsvorbereitungsberichte",
	"serviceReports.reportTypesPlural.BA": "Bestandsaufnahmeberichte",
	"serviceReports.reportTypesPlural.UV": "Sicherheitsüberprüfungsberichte",
	"serviceReports.reportTypesPlural.IG": "Aufbauberichte Gebrauchtmaschine",
	"serviceReports.reportTypesPlural.UB": "Qualitätsmaßnahmeberichte",
	"serviceReports.reportTypesPlural.PN": "Produktionsbegleitungsberichte",
	"serviceReports.reportTypesPlural.NR": "Funktionserweiterungsberichte",
	"serviceReports.reportTypesPlural.IB": "Aufbau- / Inbetriebnahmeberichte",
	"serviceReports.reportTypesPlural.II": "Installationsintegrationsberichte",
	"serviceReports.reportTypesPlural.IC": "Interne Reparatur Berichte",
	"serviceReports.reportTypesPlural.MB": "Messebetreuungsberichte",
	"serviceReports.reportTypesPlural.HW": "Ressourcenberichte",
	"serviceReports.reportTypesPlural.TT": "Technikerschulungsberichte",
	"serviceReports.reportTypesPlural.SK": "Kundeschulungsberichte",
	"serviceReports.reportTypesPlural.RP": "Reparaturberichte",
	"serviceReports.reportTypesPlural.RW": "Reparatur- und Wartungsberichte",
	"serviceReports.reportTypesPlural.WA": "Wartungsberichte",
	"serviceReports.loadMore": "Mehr laden",
	"serviceReports.loadError": "Es gab einen Fehler beim Laden der Daten",
	"serviceReports.noReportsFound": "Zur Zeit sind keine Serviceberichte vorhanden.",
	"serviceReports.noReportsAvailable": "Zur Zeit sind keine Serviceberichte vorhanden.",
	missingAuthorization: "Fehlende Berechtigung",
	"headline.createCase": "Neuen Servicefall anlegen",
	"headline.caseDetails": "Falldetails",
	"headline.contactData": "Kontaktdaten",
	"field.reason.label": "Meldungsgrund",
	"field.machine.label": "Maschine & Maschinen Nr.",
	"field.softwareProblemClassification.label": "Problemklassifikation",
	"field.softwareInstallationProblem.label": "Installationsproblem",
	"field.softwareLicenseIssue.label": "Lizenzproblem",
	"field.softwareType.label": "Software-Typ",
	"field.softwareModule.label": "Software-Modul",
	"field.errorNumber.label": "Fehlernummern",
	"field.errorNumber.explanation": "z.B. 0000FC00, 1.10.58102409 oder 6000",
	"field.errorNumber.addAnotherNumber": "weitere Fehlernummer hinzufügen",
	"field.errorNumber.errorMessage": "Ungültige Fehlernummer",
	"field.message.label": "Nachricht",
	"field.message.placeholder": "Bitte beschreiben Sie (ohne Begrüßung) so konkret wie möglich und detailliert wie nötig Ihr Anliegen/Problem. Vielen Dank.",
	"field.fileUpload.label": "Anhänge",
	"field.fileUpload.info": "Erlaubte Dateiformate: IMG, JPG, PNG, PDF, HTML, TruTops-Dateien etc. (max. 16 MB) und MP4 Video-Dateien (max. 50 MB)",
	"field.salutation.label": "Anrede",
	"field.salutation.male": "Herr",
	"field.salutation.female": "Frau",
	"field.firstName.label": "Vorname",
	"field.lastName.label": "Nachname",
	"field.email.label": "E-Mail",
	"field.phone.label": "Telefonnummer",
	"button.submit": "Senden",
	"button.cancel": "Abbrechen",
	"button.back": "zurück",
	"button.next": "weiter",
	"button.close": "Schließen",
	"button.ok": "Ok",
	"auth.error": "Ein unerwarteter Fehler ist aufgetreten.",
	"select.placeholder": "Bitte wählen ...",
	"validation.requiredField": "Dieses Feld ist ein Pflichtfeld",
	"validation.invalidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse an",
	"validation.maxAllowedCharacters": "Maximal erlaubte Anzahl an Zeichen: {{number}}",
	"validation.requiredFieldsExplanation": "Pflichtfelder sind mit einem * gekennzeichnet.",
	"validation.invalidPhoneNumber": "Bitte geben Sie eine gültige Telefonnummer ein.",
	"softwareProblemClassification.standstill": "Stillstand",
	"softwareProblemClassification.fault": "Störung",
	"softwareProblemClassification.slightImpairment": "Leichte Beeinträchtigung",
	"softwareProblemClassification.generalInquiry": "Allgemeine Anfrage",
	"serviceCase.proactiveCaseClosure.title": "Feedback & Fallschließungsantrag",
	"serviceCase.proactiveCaseClosure.instructions": "Um die Fallschließung zu beantragen und uns dabei zu helfen, unseren Predictive Service zu verbessern, bitten wir Sie höflich um Ihr Feedback.",
	"serviceCase.proactiveCaseClosure.question.submit": "Senden",
	"serviceCase.proactiveCaseClosure.dialogTitle": "Fallschließung beantragt. Danke für Ihr Feedback.",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "Ok",
	"serviceCase.proactiveCaseClosure.question.anomaly": "War die gemeldete Anomalie auf Ihrer Maschine vorhanden?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "Wurde ein Technical Guide bereitgestellt?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "Konnten Sie das Problem mithilfe des/der Technical Guides selbst lösen?",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "Möchten Sie Benachrichtigungen für diese Art von Anomalie pausieren?",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "Wie lange möchten Sie Benachrichtigungen für diese Art von Anomalie pausieren?",
	"serviceCase.proactiveCaseClosure.question.comment": "Bitte erläutern Sie, warum Sie Benachrichtigungen für diese Art von Anomalie pausieren möchten:",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "Kommentar obligatorisch, um die Fallschließung zu beantragen und Feedback zu senden",
	"serviceCase.proactiveCaseClosure.answers.yes": "Ja",
	"serviceCase.proactiveCaseClosure.answers.no": "Nein",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7 Tage",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14 Tage",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30 Tage",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90 Tage",
	"sisConnector.success.headline": "Servicefall wurde erfolgreich angelegt.",
	"sisConnector.success.orderNumberRequired.title": "Hinweis:",
	"sisConnector.success.orderNumberRequired.text": "Bitte fügen Sie auf der Falldetailseite eine Bestellnummer für die Fallabrechnung und weitere Services hinzu.",
	"sisConnector.success.technicalGuide.title": "Für diese Fehlernummer(n) ist ein Technical Guide verfügbar.",
	"sisConnector.success.technicalGuide.text": "Anhand der eingegebenen Fehlernummer(n) konnte(n) ein oder mehrere Technical Guide(s) ermittelt werden. In ca. 50% der Fälle sind Sie nun in der Lage, Ihr Problem selbständig zu lösen. Diese Funktion ist nur mit einem entsprechenden Servicevertrag verfügbar.",
	"sisConnector.success.outsideOfServiceHours": "Bitte beachten sie, dass Fälle, die außerhalb unserer Servicezeiten angelegt wurden, nicht bearbeitet werden.",
	"sisConnector.success.serviceTimes.MonFri": "Unsere Servicezeiten sind: Montag bis Freitag",
	"sisConnector.success.serviceTimes.Sat": "und Samstag",
	"sisConnector.success.withTechnicalServiceHotline": "Wenn Sie sofortige Hilfe benötigen, rufen Sie bitte den Technischen Service von TRUMPF ({{hotline}}) an, um Unterstützung zu erhalten.",
	"sisConnector.success.withoutTechnicalServiceHotline": "Wenn Sie sofortige Hilfe benötigen, rufen Sie bitte den Technischen Service von TRUMPF an, um Unterstützung zu erhalten.",
	"sisConnector.success.caseId": "Fallnummer",
	"sisConnector.failed.headline": "Der Servicefall konnte nicht angelegt werden.",
	"sisConnector.failed.unknownError": "Bitte versuchen Sie es erneut oder wenden sich an Ihren Support."
};
var deDE = {
	locale: locale,
	translations: translations
};

export { deDE as default, locale, translations };
//# sourceMappingURL=de-DE-WI2t0E86.js.map

//# sourceMappingURL=de-DE-WI2t0E86.js.map